import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'va-status-banner',
  templateUrl: './va-status-banner.component.html',
  styleUrls: ['./va-status-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule],
})
export class VaStatusBannerComponent {
  @Input() statusTitle: string;
  @Input() statusText: string;
  @Input() type: string;
  @Input() border = true;
  @Input() actionTitle: string;
  @Input() actionCallback: () => void;
}
